import { api, ApiError } from '@/api'

import type { Me } from './session-store'
import { useSessionStore } from './session-store'

/**
 * Reads the signed-in user. A 401 means there is no session: the launch from foreUP
 * happens on the server (`POST /launch`), so the UI never sees or posts a token.
 */
export async function fetchMe(): Promise<Me | null> {
  try {
    const { data } = await api.GET('/me')
    return data!
  } catch (error) {
    if (error instanceof ApiError && error.problem.status === 401) return null
    throw error
  }
}

/** Fills the session store before the first route renders, so guards never fetch. */
export async function bootstrapSession(): Promise<void> {
  const session = useSessionStore()
  try {
    const me = await fetchMe()
    if (me) session.signIn(me)
    else session.signOut()
  } catch {
    session.markUnavailable()
  }
}
